const initialUserState = {
  isAcceptedTermsPolice: false,
}

export default initialUserState
